import { useOpenedTypeState } from 'contexts/OpenedTypeContext';
import React from 'react';
import { StyledSubmitProjectFirstStep } from './style';
import { Icon, Label, SidebarDrawer, Tooltip } from 'ui';
import { useNavigate } from 'react-router-dom';
import CloseButton from 'components/CloseButton';
import { useIntl } from 'react-intl';
import { useSystemSettingState } from 'contexts/SystemSettingContext';

const SubmitProjectFirstStep = () => {
  const { openSubmitProject } = useOpenedTypeState();
  const navigate = useNavigate();
  const intl = useIntl();
  const {
    device: { isDesktop },
  } = useSystemSettingState();

  const renderDescription = () => (
    <p>
      Pašvaldības īpašumā esošās zemes vienības iekrāsotas zaļā krāsā. Ja projektu vēlēsieties iesniegt ārpus
      pašvaldības īpašumā esošajām zemes vienībām, Jums būs nepieciešams pievienot zemes īpašnieka saskaņojumu, ka viņš
      piekrīt projekta realizācijai uz viņa zemes.
    </p>
  );

  if (!isDesktop)
    return (
      <SidebarDrawer
        title={intl.formatMessage({ id: 'Atzīmē kartē projekta atrašanās vietu' })}
        isOpen={openSubmitProject}
        closeIcon={<CloseButton onClick={() => navigate('/main?participation-budget=open')} />}
        className="sidebar-style-2 submit-project-first-step"
        side="right"
        dividerVisible={false}
        showBreadcrumb={false}
        scrollShadow
      >
        {renderDescription()}
      </SidebarDrawer>
    );

  return (
    <StyledSubmitProjectFirstStep className={`custom-modal ${openSubmitProject ? 'open' : ''}`}>
      <div className="custom-modal-content">
        <Label className="title" bold={true} heading={true} label="Atzīmē kartē projekta atrašanās vietu"></Label>
        {renderDescription()}
      </div>
      <Tooltip hack title={intl.formatMessage({ id: 'project.cancel_project' })}>
        <Icon
          className="custom-modal-close"
          faBase="fal"
          icon="circle-xmark"
          onClick={() => navigate('/main?participation-budget=open')}
        />
      </Tooltip>
    </StyledSubmitProjectFirstStep>
  );
};

export default SubmitProjectFirstStep;
